// Scroll-spy for a table of contents: which section is being read right now.
//
// Lifted out of `routes/LegalPage.tsx` (the pattern the register marks as KEEP:
// sticky list with a real IntersectionObserver and an active state) so the FAQ
// can use the same one instead of a sidebar with no active state (G1-public-21).
// The observer window is the upper middle of the viewport — the band a reader's
// eyes are in — not the top edge, which would flip the active item a section early.

import { useEffect, useState } from 'react'

export function useScrollSpy(ids: string[]): string {
  const [activeId, setActiveId] = useState<string>(ids[0] ?? '')
  const key = ids.join('|')

  useEffect(() => {
    setActiveId(ids[0] ?? '')
    if (typeof IntersectionObserver === 'undefined') return
    const observer = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) { setActiveId(e.target.id); break }
        }
      },
      { rootMargin: '-30% 0px -60% 0px', threshold: 0 },
    )
    for (const id of ids) {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    }
    return () => observer.disconnect()
    // `key` is the ids joined: a new array of the same ids must not re-observe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return activeId
}

/** Scroll a section under the sticky nav rather than under it. */
export function scrollToSection(id: string, offset = 96): void {
  const el = document.getElementById(id)
  if (el) window.scrollTo({ top: el.offsetTop - offset, behavior: 'smooth' })
}
